import React, { useEffect, useRef, useState } from "react";
// import { postData } from "../../Service/ApiMethod";
// import { RECURITER_TIMESHEET } from "../../Service/service";
import WorkDetail from "./WorkDetail";

const TimeSheet = (props) => {
  const [work, setWork] = useState(false);
  // const [timeList, setTimeList] = useState();

  // const handleClick = () => {
  //   let dataObj = {
  //     timesheet_id: "5",
  //     status: "APPROVED",
  //   };
  //   postData(dataObj, RECURITER_TIMESHEET)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log(data);
  //     })
  //     .catch((err) => {
  //       console.log("Error in categories from Post Form", err);
  //       console.log(" code Error", err);
  //     });
  // };

  const ref = useRef(null);
  useOutsideAlerter(ref);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          props?.timesheetPopup && props?.timesheetPopup(false)
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  
  // useEffect(() => {
  // //   handleClick();
  // getTimeSheet();
  // }, []);
  // handleClick();
  return (
    <>
 <div className="blur-screen-full-area inner-modal flex-center">
        <div className="add-to-list-box py-0" ref={ref}>
          <div className="text-center bg-white sticky-top">
            <p className="heading mt-2">Time Sheet</p>
          </div>
          <div className="div my-3">
            <p
              className="hired-designation"
              // onChange={(e) => setTimeList(e.target.value)}
            >
              February 2021 (6 Days)
            </p>
          </div>
          <hr className="line" />

          <div className="space-between d-flex my-2">
            <p className="text" 
            // onChange={(e) => setTimeList(e.target.value)}
            >
              23 Feb, 2021
            </p>
            <button className="toggle-btn">
              <span
                className="text mr-2"
                // onChange={(e) => setTimeList(e.target.value)}
              >
                8 Hours
              </span>
              <img src="./images/toggle-down.png" alt="" />
            </button>
          </div>

          <hr className="line" />

          <div className="space-between d-flex my-2">
            <p className="text" 
            // onChange={(e) => setTimeList(e.target.value)}
            >
              23 Feb, 2021
            </p>
            <button className="toggle-btn">
              <span
                className="text mr-2"
                // onChange={(e) => setTimeList(e.target.value)}
              >
                8 Hours
              </span>
              <img src="./images/toggle-down.png" alt="" />
            </button>
          </div>

          <hr className="line" />

          <div className="space-between d-flex my-2">
            <p className="text" 
            // onChange={(e) => setTimeList(e.target.value)}
            >
              23 Feb, 2021
            </p>
            <button
              className="toggle-btn"
              onClick={() => {
                setWork(!work);
              }}
            >
              <span
                className="text mr-2"
                // onChange={(e) => setTimeList(e.target.value)}
              >
                8 Hours
              </span>
              <img src="./images/toggle-down.png" alt="" />
            </button>
          </div>

          {work ? <WorkDetail /> : null}

          <hr className="line" />

          <div className="space-between d-flex my-2">
            <p className="text" 
            // onChange={(e) => setTimeList(e.target.value)}
            >
              23 Feb, 2021
            </p>
            <button className="toggle-btn">
              <span
                className="text mr-2"
                // onChange={(e) => setTimeList(e.target.value)}
              >
                8 Hours
              </span>
              <img src="./images/toggle-down.png" alt="" />
            </button>
          </div>

          <hr className="line" />
          <div className="space-between d-flex my-2">
            <p className="text" 
            // onChange={(e) => setTimeList(e.target.value)}
            >
              23 Feb, 2021
            </p>
            <button className="toggle-btn">
              <span
                className="text mr-2"
                // onChange={(e) => setTimeList(e.target.value)}
              >
                8 Hours
              </span>
              <img src="./images/toggle-down.png" alt="" />
            </button>
          </div>

          <hr className="line" />

          <div className="div my-3">
            <p
              className="hired-designation"
              // onChange={(e) => setTimeList(e.target.value)}
            >
              February 2021 (6 Days)
            </p>
          </div>
          <hr className="line" />

          <div className="space-between d-flex my-2">
            <p className="text" 
            // onChange={(e) => setTimeList(e.target.value)}
            >
              23 Feb, 2021
            </p>
            <button className="toggle-btn">
              <span
                className="text mr-2"
                // onChange={(e) => setTimeList(e.target.value)}
              >
                8 Hours
              </span>
              <img src="./images/toggle-down.png" alt="" />
            </button>
          </div>

          <div className="space-between d-flex my-2">
            <p className="text" 
            // onChange={(e) => setTimeList(e.target.value)}
            >
              23 Feb, 2021
            </p>
            <button className="toggle-btn">
              <span
                className="text mr-2"
                // onChange={(e) => setTimeList(e.target.value)}
              >
                8 Hours
              </span>
              <img src="./images/toggle-down.png" alt="" />
            </button>
          </div>

          <div className="space-between d-flex my-2">
            <p className="text"
            // onChange={(e) => setTimeList(e.target.value)}
            >
              23 Feb, 2021
            </p>
            <button className="toggle-btn">
              <span
                className="text mr-2"
                // onChange={(e) => setTimeList(e.target.value)}
              >
                8 Hours
              </span>
              <img src="./images/toggle-down.png" alt="" />
            </button>
          </div>

          <div className="div w-100 sticky-bottom pb-2 bg-white">
            <button
              className="theme-btn w-100 btn-block"
              onClick={(e)=>{
                e.stopPropagation()
                props?.timesheetPopup(false)
              }
               }
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TimeSheet;
